import React from "react";
import './WhyChooseUs.css';
import centertickicon from '../../Images/choose-card-center-img.svg';
import sidetickicons from '../../Images/choose-card-left-right-img.svg';

const WhyChooseUs = () => {
    return (
        <>
            <div className="why-choose-us-section">
                <div className="why-choose-us-container">
                    <h4 className="choose-title">Stockport Solutions</h4>
                    <h2 className="choose-subtitle">Why Choose Us ?</h2>
                    <p className="choose-description">We prioritize high standards across every product and service we deliver, ensuring reliability, compliance, and long-term value.</p>
                </div>
                <div className="choose-cards-container">
                    <div className="choose-card">
                        <img src={sidetickicons} alt="choose-icons" className="choose-icons" />
                        <h3 className="card-heading">Quality Products</h3>
                        <p className="card-intro">We deliver only the best, ensuring top-notch quality in every item we sell.</p>
                    </div>
                    <div className="choose-card">
                        <img src={centertickicon} alt="choose-icon" className="choose-icons" />
                        <h3 className="card-heading">Trusted by Customers</h3>
                        <p className="card-intro">Hundreds of happy customers trust us for our reliability and great service.</p>
                    </div>
                    <div className="choose-card">
                        <img src={sidetickicons} alt="choose-icons" className="choose-icons" />
                        <h3 className="card-heading">Quality Products</h3>
                        <p className="card-intro">We deliver only the best, ensuring top-notch quality in every item we sell.</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default WhyChooseUs